/** @jsxImportSource @emotion/react */
import { SerializedStyles } from '@emotion/react'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Icon } from '@app/components/Atoms/Icon'
import React from 'react'
import { sidebarMenuItemContainer, sidebarMenuItemLabel } from './SidebarMenuItem.style'

export interface SidebarButtonProps {
  icon: string | React.ReactNode
  label: string
  onClick: (() => void | null) | ((e: React.MouseEvent<HTMLButtonElement>) => void)
  displayLabel?: boolean
  id?: string
  active?: boolean
  disabled?: boolean
  hidden?: boolean
  size?: 'small' | 'medium' | 'large' | 'fit'
  badge?: React.ReactNode
  customClass?: {
    iconClass?: SerializedStyles
    labelClass?: SerializedStyles
    buttonClass?: SerializedStyles
  }
  testId?: string
  loaded?: boolean
}

export const SidebarMenuItem: React.FC<SidebarButtonProps> = ({
  icon,
  label,
  onClick,
  displayLabel = false,
  id,
  disabled = false,
  active = false,
  hidden = false,
  customClass,
  testId,
  badge,
  size = 'large',
  loaded = true,
}) => {
  const theme = useTheme()

  const iconColour = active ? theme.palette.primary.main : (theme.palette.white?.main ?? 'white')

  if (!loaded) return null

  return (
    <Box
      title={label}
      component="button"
      css={[
        sidebarMenuItemContainer({ theme, active, displayLabel, disabled, hidden }),
        customClass?.buttonClass,
      ]}
      id={id}
      data-testid={testId}
      onClick={!disabled ? onClick : undefined}
    >
      <Box css={customClass?.iconClass}>
        <Icon iconName={icon as string} colour={iconColour} size={size} active={active} />
      </Box>

      <Box
        css={[
          sidebarMenuItemLabel({ theme, active, disabled, displayLabel }),
          customClass?.labelClass,
        ]}
      >
        <Typography variant="body1">{label}</Typography>
        {badge}
      </Box>
    </Box>
  )
}

export default SidebarMenuItem
